import React from 'react';
import { DashboardLayout } from '../layouts';

const Dashboard: React.FC = () => (<DashboardLayout />);

export default Dashboard;